module.exports = __webpack_public_path__ + "img/vizio1-cover-2.58505570.jpg";